import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import authReducer from './slices/authSlice';
import tenantReducer from './slices/tenantSlice';
import notificationReducer from './slices/notificationSlice';
import connectionReducer from './slices/connectionSlice';
import dataFlowReducer from './slices/dataFlowSlice';
import analyticsReducer from './slices/analyticsSlice';
import flowDefinitionReducer from './slices/flowDefinitionSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    tenant: tenantReducer,
    notification: notificationReducer,
    connection: connectionReducer,
    dataFlow: dataFlowReducer,
    analytics: analyticsReducer,
    flowDefinition: flowDefinitionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['auth/loginSuccess'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
